import { Component , Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalOptions } from '../../models';
import { ModalWrapperComponent } from '../modal-wrapper/modal-wrapper.component';

@Component({
  selector: 'app-search-save-popup',
  standalone: true,
  imports: [ModalWrapperComponent],
  templateUrl: './delete-confirmation-popup.component.html',
  styleUrls: ['./delete-confirmation-popup.component.scss']
})
export class DeleteConfirmationPopupComponent implements OnInit {
  @Input() options: ModalOptions = new ModalOptions();
  @Input() params: any[] = [];
  saveName: string = "";
  msg: string = "";
  isValid: boolean = true;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    if (this.params[0].usedFor == 'SearchDelete') {
      this.msg = 'Are you sure want to delete this query?';
    }
    else if (this.params[0].usedFor == 'CurationDelete') {
      this.msg = 'Are you sure you want to approve this request?';
    }
  }
  onSave(event: any) {
    this.activeModal.close(this.saveName);
  }

  onCancel(event: any) {
    this.activeModal.dismiss(event);
  }

}
